import {Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild} from '@angular/core';
import {CommonModule, DatePipe, NgOptimizedImage} from '@angular/common';
import {ApiService} from '@services/api.service';
import {HttpClientModule} from '@angular/common/http';
import {UtilsService} from '@services/utils.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ImsDetail, ImsDocumentDetaiLDownload, ImsDocumentDetailListResponse} from '../../models/output.model';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-ims-detail',
  imports: [
    DatePipe, CommonModule, HttpClientModule, NgOptimizedImage
  ],
  templateUrl: './ims-detail.component.html',
  styleUrl: './ims-detail.component.css'
})
export class ImsDetailComponent implements OnInit {

  items$!: Observable<ImsDetail>;
  @Output() goBackToProcedures = new EventEmitter<void>();

  @ViewChild('iframe') private iframeElement! : ElementRef<HTMLIFrameElement>;

  @HostListener('document:keyup.escape', ['$event'])

  handleEscapeKey() {
    this.closePreview();
  }

  constructor(
    private utilsSvc: UtilsService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  goBack() {
    this.router.navigate(['/documenti-sgi'])
    this.goBackToProcedures.emit()
  }

  ngOnInit(): void {
    this.fetchProcedure()
  }

  fetchProcedure() {
    const id = this.route.snapshot.paramMap.get('id') || 0;
    this.items$ = this.apiService.getImsDocumentDetail(+id).pipe(map((res: ImsDocumentDetailListResponse) => res.data))
  }

  downloadDocument(id: number, type: string) {
    this.apiService.getDocument(id).subscribe((response: ImsDocumentDetaiLDownload) => {
      this.utilsSvc.transformBlobToLink(response, type);
    });
  }

  previewDocument(id: number, type: string) {
    this.apiService.getDocument(id).subscribe((response: ImsDocumentDetaiLDownload) => {
      this.iframeElement.nativeElement.setAttribute('src',`data:${type};base64,${response.data.base64}`);
    });
  }

  closePreview() {
    this.iframeElement.nativeElement.removeAttribute('src');
  }
}
